/**
 * Get the duration of a video creating a video element
 * @param video 
 * @returns 
 */
export async function getVideoDuration(video?: File): Promise<number> {
    if (!video) return 0;

    return await new Promise((resolve, reject) => {
        const videoElement = document.createElement('video');
        videoElement.preload = 'metadata';
        videoElement.onloadedmetadata = () => {
            window.URL.revokeObjectURL(videoElement.src);
            resolve(videoElement.duration);
        }
        videoElement.onerror = reject;
        videoElement.src = URL.createObjectURL(video);
    });
}

/**
 * Serialize a video duration using the whole seconds expected by the upload API.
 */
export function formatVideoDurationForUpload(duration: number): string {
    return Math.floor(duration).toString();
}

/**
 * Normalize the name of a video to avoid problems with the extension
 * @param name
 * @param extension
 * @returns 
 */
export function normalizeVideoName(name: string, extension: string): string {
    return name
        .replace('.mp4', '')
        .replace('.mov', '')
        .replace('.avi', '')
        .replace('.mkv', '')
        .replace('.webm', '')
        .replace('.wmv', '')
        .replace(/[^A-Z0-9]/gi, '_')
        .concat(`.${extension}`);
}
